import styled from "styled-components"
import { Link } from "../../../../ui"
import {
  MenuItemWrapperStyles,
  MenuLinkStyles,
  SubmenuItemStyles,
  SubmenuWrapperStyles,
} from "./menu-item-styles"

export const MenuItemWrapper = styled.li`
  &:hover ul {
    display: flex;
  }
  ${MenuItemWrapperStyles}
`

export const MenuLink = styled(Link)`
  padding: 0 30px;
  height: 60px;
  display: flex;
  align-items: center;
  ${MenuLinkStyles}
`

export const SubmenuItem = styled.li`
  line-height: 50px;
  padding: 0 30px;
  ${SubmenuItemStyles}
`

export const SubmenuWrapper = styled.ul`
  background: #aaa;
  position: absolute;
  display: none;
  flex-direction: column;
  ${SubmenuWrapperStyles}
`
